"use client"

import * as React from "react"
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group"

import { cn } from "@/lib/utils"

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn("grid gap-2", className)}
      {...props}
      ref={ref}
    />
  )
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "peer relative aspect-square size-5 shrink-0 rounded-full border-[1.5px] border-outline bg-transparent text-primary transition-colors duration-[var(--duration-short-3)] ease-[var(--ease-emphasized)] motion-reduce:transition-none focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-2 before:absolute before:left-1/2 before:top-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:size-10 before:rounded-full before:bg-foreground/8 before:opacity-0 before:transition-opacity before:duration-[var(--duration-short-3)] before:ease-[var(--ease-emphasized)] motion-reduce:before:transition-none before:content-[''] hover:before:opacity-100 active:before:bg-foreground/12 active:before:opacity-100 data-[state=checked]:border-primary data-[state=checked]:hover:before:bg-primary/8 data-[state=checked]:active:before:bg-primary/12 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none disabled:hover:before:opacity-0",
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="relative z-10 flex items-center justify-center">
        {/* The Indicator only mounts when checked, so the dot zooms in on
            select. The previous `data-[state=checked]:scale-100` selector sat
            on this inner span — which never receives a `data-state` attribute
            (Radix sets it on the Indicator) — so the dot was pinned at scale-0
            and never showed. */}
        <span className="size-2.5 rounded-full bg-primary animate-in zoom-in-50 duration-[var(--duration-short-3)] ease-[var(--ease-emphasized)] motion-reduce:animate-none" />
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  )
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
